
const digest = 'fb542b50563e254055859f210a827bb5b6b97716282539afa985037dfd8f8295';
const classes = {"button":"_button_oa1q2_1","controlsWrapper":"_controlsWrapper_oa1q2_21","cancelButton":"_cancelButton_oa1q2_26"};
const css = `._button_oa1q2_1 {
  border-color: #d81616;
  background-color: #d81616;
  font-family: Rubik, sans-serif;
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 13px 16px;
  justify-content: center;
  height: fit-content;
  width: fit-content;
  margin-top: 20px;
  border-radius: 25px;
}
._button_oa1q2_1:hover, ._button_oa1q2_1:active, ._button_oa1q2_1:focus {
  border-color: #b00b0b !important;
  background-color: #b00b0b !important;
}

._controlsWrapper_oa1q2_21 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
._controlsWrapper_oa1q2_21 ._cancelButton_oa1q2_26 {
  margin-top: 20px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  